module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;
    import IntDetail = Meevo.Model.IntDetail;
    import ISecurityAttributes = Meevo.Model.ISecurityAttributes;
    import ProactiveAlertTypeEnum = Meevo.Model.ProactiveAlertTypeEnum;

    interface ISecurityAlertJson extends IAlertJSON {
        securityAttributes: ISecurityAttributes[];
    }

    const MAX_SELECT_KEYS = 10;

    class MeevoSecurityOverrideOccursConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            '$q',
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedSecurityFeature: IntDetail;

        public securityKeyList: Array<ISecurityAttributes> = [];
        public unnecessarySecurityKeys = ['field', 'status', 'copy'];

        public securityFeatureCriteria = {
            filter: '%',
            excludeIdList: [
                11039643,	//	5 Star Ratings Settings
                38000,      //	Activity Log
                11039623,	//	ADP Integration
                38100,	//	Alerts Log
                38200,	//	Alerts Manager
                1000,	//	Appointment Cancellation Reasons
                1200,	//	Appointment Category
                1100,	//	Block Types
                11039741,	//	Book a Remote Training
                10300,	//	Booking Agent
                400,	//	Business Information
                2004500,	//	Client Intake Form
                3039200,	//	Client Point Promotions
                3500,	//	Client Type
                1000006,	//	Community Site
                10600,	//	Confirmation Manager
                417,	//	Currency & Tax
                3004200,	//	Departments
                41200,	//	Discounts
                2100,	//	Distributor
                43000,	//	Drawer History
                41000,	//	Drawers
                3100700,	//	Emma
                500,        //	Employee
                700,	//	Employee Categories
                3039100,	//	Employee Goals
                1800,	//	Employee Promotion
                60300,	//	Employee Supply Usage
                800,	//	Employee Template
                1600,	//	Equipment
                80200,	//	Event Schedule
                3000034,	//	Floor Locations
                1000001,	//	Gift Card Liability Indicator
                3000002,	//	Gift Card Lookup
                1700,	//	Gift Card Types
                3039300,	//	Goals Dashboard
                1000007,	//	Help
                413,	//	Holidays
                34000,	//	Integration
                30300,	//	IP Restriction
                1900,	//	Manufacturer
                2045000,	//	Mark Items on Sale
                11039733,	//	Meevo Business Intelligence
                11039767,	//	Meevo System Toolbox
                3400,	//	Membership Benefit Templates
                90400,	//	Membership Cancellation Reasons
                3100,	//	Membership Types
                3300,	//	Memberships
                3600,	//	Merchant Accounts
                1000008,	//	Millennium Academy
                11039740,	//	Millennium Inspo
                60500,	//	Misc Supply Definitions
                403,	//	Notification
                80500,	//	Notification Template
                30200,	//	Online Booking Settings
                11039819,	//	Online Presence Management
                11039826,	//	Online Presence Settings
                3039000,	//	Overall/Department Goals
                3000,	//	Package
                3000003,	//	Package Lookup
                3100500,	//	Paging Settings
                40020,	//	Pay In/Out Reasons
                2300,	//	Payment Type
                41100,	//	POS Hardware
                37100,	//	Price Management
                2000,	//	Product
                4000,	//	Product Bundle
                2200,	//	Product Category
                33000,	//	Profile Settings
                60400,	//	QuickBooks Desktop
                200,	//	Referral Type
                50018,	//	Report Limitations
                2055000,	//	Report Scheduler
                50006,      //	Reports
                1500,	//	Resource
                1300,	//	Resource Categories
                2039500,	//	Sales Ranking
                30001,	//	Security Roles
                5010700,	//	Self Check-In Kiosk
                5080800,	//	Self Check-In Kiosk Settings
                3800,	//	Serv. Add-on Mappings
                900,	//	Service Categories
                11039662,	//	Service Charges
                600,	//	Services
                3900,	//	Smart Center Designer
                10500,	//	Standing Appointments
                10100,	//	Standing Blocks
                10004300,   //	Student
                3200,	    //	Swap Groups
                10004400,   //	Teacher
                3100800,	//	TechSphere
                3100600,	//	Transworld
                11039716,	//	Vanguard ID
                300,	//	Visit Note Type
                10400,	//	Wait List
                10213,	//	Walk-In Manager
                10218,	//	Walk-In Manager Display
                10219,	//	Walk-In Manager Kiosk
                10200,	//	Walk-In Manager Settings
                1400,	//	Work Activities
                11039754,	//	Yield Management Program
                11039795, // ADP WFN Integration
                100700, // Aveda
                11039714, // CardConnect
                3100400, // Textel
                11039727, // TextelBlast
                11039712, // Worldpay
                11039748, // Yield Management Strategy
                11039887, // Meevo Facebook Groups
                11039794, // Meevo Messenger,
                11039791, // Meevo Messenger Settings
                11039736, // QuickBooks Desktop
                310100, // QuickBooks Online
                11039718, // REACH by Octopi
                11039885, // Refer a Friend
                3100300, // SalonClouds + Settings
            ]
        };

        get dataForReview() {
            return (this.securityKeyList || [])
                .filter((s) => s.selected)
                .map((item) => item.securityKey);
        }

        get alertConfiguration() {
            return {
                securityAttributes: (this.securityKeyList || []).filter((s) => s.selected)
            };
        }

        get isSecuredFeatureAccessedAlert(): boolean {
            const allowedAlertTypeEnum = [
                ProactiveAlertTypeEnum.SecuredFeatureAccessed,
                ProactiveAlertTypeEnum.SecurityOverrideOccured,
                ProactiveAlertTypeEnum.AccessIsDeniedToACertainFeature
            ]

            return allowedAlertTypeEnum.indexOf(this.params.alertSetting.alertType) !== -1;
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    private modalService: Meevo.Components.Modal.ModalService,
                    private _$q: ng.IQService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: ISecurityAlertJson): void {
            let securityAttributes = alertJSON.securityAttributes;

            if (this.isSecuredFeatureAccessedAlert && securityAttributes.length > MAX_SELECT_KEYS) {
                securityAttributes = securityAttributes.slice(0, MAX_SELECT_KEYS);
                this.modalService.alert('MESSAGE_CANNOT_SELECT_MORE_10');
            }

            this.alertsManagerService.getFeatureList().then(featureList => {
                this.securityKeyList = securityAttributes.map(item => {
                    item.selected = true;

                    if (typeof item.fullDisplayName === 'string') return item;

                    const itemFirstLevel = featureList.find(feature => {
                        if (item.level === 2) return feature.id.toString() === item.id.toString();

                        return feature.id.toString() === item.parentId.toString();
                    });

                    if (!itemFirstLevel) return item;

                    return {
                        ...item,
                        fullDisplayName: `${itemFirstLevel.displayName}: ${item.displayName}`
                    }
                });
            });
            if (this.allItemsHasFullDisplayName(securityAttributes)) {
                this.securityKeyList = securityAttributes;
            } else {
                this.generateFullDisplayNameForItems(securityAttributes);
            }
        }

        /**
         * User selects another security feature
         */
        securityFeatureChanged(): void {
            this.params.isNoSecurityKeyExists = null;
            if (!this.selectedSecurityFeature) return;

            this.busyService.start();

            const getData = this.isSecuredFeatureAccessedAlert
                ? this.alertsManagerService.getSecurityManagerKeysForSecuredFeature(this.selectedSecurityFeature.id)
                : this.alertsManagerService.getSecurityManagerKeys(this.selectedSecurityFeature.id);

            getData
                .then((data: any) => {
                    const firstLevel = data.securityAttributes.find((item: ISecurityAttributes) => item.level === 2);

                    this.resetToSelectedOnly();

                    if (this.isSecuredFeatureAccessedAlert && !this.isSecurityAttributesHasAvailable(data.securityAttributes)) {
                        this.modalService.alert('MESSAGE_NO_SECURITY_KES_AVAILABLE');
                        this.params.isNoSecurityKeyExists = true;
                        return;
                    }

                    this.updateSecurityKeyList(firstLevel, this.selectedSecurityFeature.displayName);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        selectCallback(level: ISecurityAttributes) {
            if (!this.isSecuredFeatureAccessedAlert) {
                return;
            }

            if ((this.securityKeyList || []).filter((s) => s.selected).length > MAX_SELECT_KEYS) {
                level.selected = false;
                this.modalService.alert('MESSAGE_CANNOT_SELECT_MORE_10');
            }
        }

        /**
         * Check if we need to display particular security key
         */
        isUnnecessaryKey(key: string): boolean {
            return this.unnecessarySecurityKeys.some((k) => key.toLowerCase().indexOf(k) !== -1);
        }

        getSecurityManagerKeys(id: number) {
            return this.isSecuredFeatureAccessedAlert ?
                this.alertsManagerService.getSecurityManagerKeysForSecuredFeature(id)
                : this.alertsManagerService.getSecurityManagerKeys(id);
        }

        private generateFullDisplayNameForItems(items: ISecurityAttributes[]) {
            const secondLevelUniqueIDs = new Set<string>();

            this.securityKeyList = items.filter(item => item.fullDisplayName);

            items
                .filter(item => !item.fullDisplayName)
                .forEach(item => {
                    const _second = item.hierarchyMaterialized.split('/')[2];
                    secondLevelUniqueIDs.add(_second);
                });

            this._$q.all([...Array.from(secondLevelUniqueIDs)].map(id => {
                return this.getSecurityManagerKeys(+id)
                    .then(({ securityAttributes }) => {
                        const firstLevel = securityAttributes.find((item: ISecurityAttributes) => item.level === 2);

                        if (firstLevel) {
                            this.updateSecurityKeyList(firstLevel, firstLevel.displayName);
                        }
                    })
            }))
                .then(() => {
                    this.securityKeyList = this.securityKeyList
                        .map(item => ({
                            ...item,
                            selected: items.some(_item => _item.id === item.id)
                        }))
                        .filter(item => item.selected);
                })

        }

        private resetToSelectedOnly() {
            this.securityKeyList = this.securityKeyList.filter((item) => item.selected);
        }

        private allItemsHasFullDisplayName(securityAttributes: ISecurityAttributes[]): boolean {
            return securityAttributes.every(item => typeof item.fullDisplayName === 'string')
        }

        /**
         * Update security key list
         */
        private updateSecurityKeyList(level: ISecurityAttributes, parentDisplayName: string): void {
            if (this.validToAddToSecurityKeyList(level)) {
                level.fullDisplayName = level.fullDisplayName || `${parentDisplayName}: ${level.displayName}`;
                this.securityKeyList.push(level);
            }

            if (level.children) {
                for (const child of level.children) {
                    this.updateSecurityKeyList(child, level.fullDisplayName || level.displayName);
                }
            }
        }

        private isSecurityAttributesHasAvailable(securityAttributes: ISecurityAttributes[]): boolean {
            return securityAttributes.some((item: ISecurityAttributes) => item.level === 2);
        }

        private isUnnecessaryLevel(level: number): boolean {
            return [1, 9].indexOf(level) !== -1;
        }

        private validToAddToSecurityKeyList(level: ISecurityAttributes): boolean {
            return !this.alreadyInTheSecurityList(level)
                && !this.isUnnecessaryKey(level.securityKey)
                && !this.isUnnecessaryLevel(level.level)
                ;
        }

        private alreadyInTheSecurityList(level: ISecurityAttributes): boolean {
            return this.securityKeyList.some((k) => k.id === level.id);
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoSecurityOverrideOccursConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/security-override-occurs-config/security-override-occurs-config.component.html',
            controller: MeevoSecurityOverrideOccursConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}
